import React, { FC, ComponentProps, useCallback } from 'react';
import { PartySuggestions, DaDataSuggestion, DaDataParty } from 'react-dadata';
import { TextField } from '@mui/material';

import { cn, ClassName } from 'Modules/ui';
import { wrapFormComponent } from 'Modules/core/forms';

import { Typography } from '../Typography';
import styles from './index.module.scss';


const token = 'f47078270dcde409c92d9fdef88e6f9ec32f6bc7';


type ParticipantOptionProps = ClassName & {
    data: DaDataSuggestion<DaDataParty>;
    onClick?: () => void;
}

const ParticipantOption: FC<ParticipantOptionProps> = ({ data, className, onClick }) => (
    <div className={className} onClick={onClick}>
        <Typography
            component='div'
            variant='mediumBody1'
            title={data.data.name.short_with_opf}
            noWrap
        >
            {data.data.name.short_with_opf?.replace(/['"]+/g, '')}
        </Typography>
        <Typography
            component='div'
            variant='mediumBody1'
            sx={{
                opacity: 0.5,
            }}
        >
            {data.data.name.short_with_opf?.replace(/['"]+/g, '')}
        </Typography>
    </div>
);

const ParticipantInput = React.forwardRef<HTMLInputElement, any>(({
    data,
    error,
    active, value,
    ...props
}, ref) => (
    <TextField
        inputRef={ref}
        variant='filled'
        fullWidth
        error={!!error}
        helperText={error}
        value={data?.value || data}
        InputLabelProps={{ required: false }}
        {...props}
    />
));

export const ParticipantSelect: FC<Omit<ComponentProps<typeof PartySuggestions>, 'token'>> =
    ({
        inputProps: { className, ...inputProps },
        value, onChange, ...props
    }) => (
        <PartySuggestions
            token={token}
            value={value}
            onChange={onChange}
            suggestionsClassName={styles.suggestions}
            suggestionClassName={styles.suggestion}
            containerClassName={cn(className, styles.container)}
            customInput={ParticipantInput}
            inputProps={{
                ...inputProps,
                autoComplete: 'off',
                // @ts-ignore
                data: value,
            }}
            renderOption={useCallback(
                participant => <ParticipantOption data={participant} />,
                [],
            )}
            {...props}
        />
    );

export const ParticipantSelectField = wrapFormComponent(({
    name,
    value,
    onChange,
    onBlur,
    onFocus,
    ...props
}) => (
    <ParticipantSelect
        inputProps={{
            name,
            onBlur,
            onFocus,
            onChange,
            ...props,
        }}
        value={value}
        onChange={onChange}
    />
));
